import {useEffect, useState} from 'react';
import {useCustomer} from "../../../layouts/SelfcareLayout";
import SelfcarePageContent from "../../../components/selfcare/SelfcarePageContent";
import {selfcareNextInvoice} from "../../../util/request";
import {InvoiceLine, NextInvoice} from "../../../util/types";
import {formatAmount, formatDate, formatPeriod} from "../../../util/formatter";
import {BackButton} from "../../../components/selfcare/BackButton";
import LoaderSpinner from '../../../components/loaders/LoaderSpinner';
import Routing from "../../../Routing.ts";

export default function NextInvoicePage() {
    const {customer} = useCustomer()

    const [loading, setLoading] = useState<boolean>(true)
    const [nextInvoice, setNextInvoice] = useState<NextInvoice | null>(null)

    useEffect(() => {
        setLoading(true)
        selfcareNextInvoice(customer.customer_id).then((response) => {
            setNextInvoice(response.response.data)
            setLoading(false)
        })
    }, [customer.customer_id])

    if (loading || nextInvoice === null) return <LoaderSpinner/>

    const visibleInvoiceLines = nextInvoice.invoice_lines.filter((invoiceLine: InvoiceLine): boolean => invoiceLine.amount_total !== null)

    return <SelfcarePageContent>
            <div className="selfcare-page-summary">
                <h1 className="heading heading--big">Kommende regning</h1>
                <p>Få et overblik over hvad du skal betale på din næste regning.</p>
            </div>
            <BackButton default_url={Routing.Selfcare.Bills}/>
            <table className='selfcare-invoice-table'>
                <thead>
                    <tr>
                        <th>Abonnement</th>
                        <th>Periode</th>
                        {nextInvoice.due_date &&<th>Forfaldsdato</th>}
                        <th>Beløb</th>
                    </tr>
                </thead>
                <tbody>
                    {visibleInvoiceLines.map((invoiceLine: InvoiceLine, index: number) => (
                        <tr key={index}>
                            <td>{invoiceLine.invoice_display_name}</td>
                            <td>{formatPeriod(invoiceLine.period_start, invoiceLine.period_end)}</td>
                            {nextInvoice.due_date && <td>{formatDate(nextInvoice.due_date)}</td>}
                            <td>{formatAmount(invoiceLine.amount_total as string)}</td>
                        </tr>
                    ))}
                </tbody>
                <tfoot>
                    <tr>
                        <td colSpan={nextInvoice.due_date ? 3 : 2}><strong>Total</strong></td>
                        <td><strong>{formatAmount(nextInvoice.sum)}</strong></td>
                    </tr>
                </tfoot>
            </table>
        </SelfcarePageContent>
}
